import angular from 'angular';

class BoUserDetails {
    /*@ngInject*/
    constructor(
        toastr,
        $translate,
        $state,
        KissUserDA,
        LANGUAGES,
        $filter,
        UserEdit,
        UserAssignments,
        KISS_USER,
        DOMAIN,
        AuthSvc
    ) {
        this.toastr = toastr;
        this.$translate = $translate;
        this.formDisabled = true;
        this.$state = $state;
        this.KissUserDA = KissUserDA;
        this.LANGUAGES = LANGUAGES;
        this.$filter = $filter;
        this.UserEdit = UserEdit;
        this.UserAssignments = UserAssignments;
        this.KISS_USER = KISS_USER;
        this.DOMAIN = DOMAIN;
        this.AuthSvc = AuthSvc;
    }

    $onInit() {
        let vm = this;
        vm.includes = {
            errorMessages: require('../../../app/layouts/error-messages.html'),
        };
        this.allRoles = ['USER_BO', 'PRODUCT', 'SUPPORT', 'OPERATION', 'CONFIGURATOR', 'ADMIN'];
        this.roles = [];
        if (!this.isAuthorized('ADMIN')) {
            this.allRoles.pop();
        }
        if (!vm.bouser) {
            vm.bouser = {};
            vm.mode = 'creation';
            this.formDisabled = false;
            vm.bouser.domain = vm.DOMAIN.cegedim;
            vm.bouser.status = 'ACTIVE';
            vm.bouser.language = 'fr';
        } else {
            this.formDisabled = true;
            if (vm.bouser.roles.includes('USER_BO')) {
                this.roles.push('USER_BO');
            }
            if (vm.bouser.roles.includes('SUPPORT')) {
                this.roles.push('SUPPORT');
            }
            if (vm.bouser.roles.includes('OPERATION')) {
                this.roles.push('OPERATION');
            }
            if (vm.bouser.roles.includes('CONFIGURATOR')) {
                this.roles.push('CONFIGURATOR');
            }
            if (vm.bouser.roles.includes('ADMIN')) {
                this.roles.push('ADMIN');
            }
            if (vm.bouser.roles.includes('PRODUCT')) {
                this.roles.push('PRODUCT');
            }
        }
    }

    enableForm() {
        this.formDisabled = this.roles.includes('ADMIN') && !this.isAuthorized('ADMIN');
    }

    save() {
        var ctrl = this;
        if (ctrl.form.$valid) {
            var userEdit = new this.UserEdit();
            userEdit.setUser(this.bouser);
            userEdit.setAssignments(this.getUserAssignments());

            this.KissUserDA.saveUserBo(userEdit).then(
                function () {
                    ctrl.toastr.success(ctrl.$translate.instant('commons.saved'));
                    ctrl.formDisabled = true;
                    if (ctrl.mode === 'creation') {
                        ctrl.$state.go('app.bouser.list');
                    } else {
                        ctrl.mode = 'details';
                    }
                },
                function (error) {
                    ctrl.toastr.error('Echec de sauvegarde', error);
                }
            );
        }
    }

    /**
     * Créé un tableau contenant les roles de l'utilisateurs.
     */
    getUserAssignments() {
        var assignments = [];
        assignments.push(new this.UserAssignments('USER_BO'));

        if (this.roles.includes('SUPPORT')) {
            assignments.push(new this.UserAssignments('SUPPORT'));
        }
        if (this.roles.includes('OPERATION')) {
            assignments.push(new this.UserAssignments('OPERATION'));
        }
        if (this.roles.includes('CONFIGURATOR')) {
            assignments.push(new this.UserAssignments('CONFIGURATOR'));
        }
        if (this.roles.includes('ADMIN')) {
            assignments.push(new this.UserAssignments('ADMIN'));
        }
        if (this.roles.includes('PRODUCT')) {
            assignments.push(new this.UserAssignments('PRODUCT'));
        }
        return assignments;
    }

    /**
     * Sélectionne les rôles enfants du rôle sélectionné
     * @param  roles
     */
    roleChecked(roles) {
        angular.forEach(roles, role => {
            var roleTree = this.KISS_USER.rolesTree.find(roleTree => roleTree.role === role);
            this.selectChildRoles(roleTree);
        });
    }

    selectChildRoles(roleTree) {
        var vm = this;
        if (roleTree.childs.length > 0) {
            roleTree.childs.forEach(child => {
                vm.changeRoleSelectionValue(child);
                vm.selectChildRoles(vm.KISS_USER.rolesTree.find(roleTr => roleTr.role === child));
            });
        }
    }

    changeRoleSelectionValue(role) {
        if (!this.roles.includes(role)) {
            this.roles.push(role);
        }
    }

    translatedLanguage(language) {
        return this.$filter('translate')(language);
    }

    isAuthorized(role) {
        return this.AuthSvc.isAuthorized(role);
    }
}

angular.module('app.bouser').component('bouserDetails', {
    templateUrl: require('./bo-user-details.html'),
    controller: BoUserDetails,
    bindings: {
        bouser: '<',
    },
});
